import { addEventToDatalayer } from '../../@helpers/js/datalayer.js';
import { wait } from '../../@helpers/js/wait.js';

class CompareInsuranceTable {

	constructor(element, {
		toggleclass = 'c-toggle-detail-on',
		highlightclass = 'c-table-row-highlight',
		searchPlaceholder = 'Begin hier met typen',
		searchText = 'Geen passend resultaat gevonden',
	} = {}) {

		this._element = element;
		this._options = {
			toggleclass,
			highlightclass,
			searchPlaceholder,
			searchText
		};

		this.init();
	}

	init() {
		this._tableBody = this._element.querySelector('table tbody');
		this._revealerColl = this._element.querySelector('.c-revealer-collection');
		this._selectBox = this._element.querySelector('.c-insurance-compare__select .c-insurance-compare__combobox__list');
		this._selectOptions = this._selectBox ? [...this._selectBox.querySelectorAll('li[role=option]')] : [];
		this._noneleft = this._element.querySelector('[data-insurance-compare-none]');
		this._tablerows = this._tableBody ? [...this._tableBody.querySelectorAll('tbody tr')].map((row) => {
			return {
				row,
				name: row.dataset?.tablerow,
				toggleBtn: row.querySelector('th button[data-module=ToggleButton]'),
				rem: row.querySelector('button[data-insurance-compare-hider]')
			};
		}) : [];
		this._revealerrows = this._revealerColl ? [...this._revealerColl.querySelectorAll('[data-revealerrow]')].map((row) => {
			return {
				row,
				name: row.dataset?.revealerrow,
				toggleBtn: row.querySelector('button[data-module=ToggleButton]'),
				rem: row.nextElementSibling,
				rev: row.querySelector('[data-revealer-title]'),
			};
		}) : [];
		
		if (this._tablerows?.length > 0 && this._revealerrows?.length > 0) {
			this._comboBox = this._element.querySelector('input[role="combobox"]');
			this._selectConfirm = this._element.querySelector('button[data-confirm-selection]');

			// add click listener
			if (this._selectConfirm) {
				this._selectConfirm.addEventListener('click', () => {
					// get selected value from slimselect
					let selected = this._selectOptions.length >= 1 && this._comboBox?.value ? this._selectOptions?.find(o => o.innerText === this._comboBox.value) : '';
					if (selected) {
						if (selected.innerText) {
							let options;
							try {
								options = JSON.parse(this._selectConfirm.dataset.confirmDatalayerClick);
								options.event = 'event';
								options.label = selected.innerText;
								setTimeout( () => addEventToDatalayer(options), 100);
							} catch (error) {
								console.error(error);
							}
						}
						
						
						// get correct row by value
						const trow = this._tablerows.find((r) => r.name === selected.id)
						// get correct revealerrow by value
						const rrow = this._revealerrows.find((r) => r.name === selected.id)
						if (trow && rrow) {
							// move row to bottom and remove t-hidden class
							this._tableBody.appendChild(trow.row);
							trow.row.classList.remove('t-hidden');
							
							// move revealerrow to bottom and remove t-hidden class
							this._revealerColl.appendChild(rrow.row);
							this._revealerColl.appendChild(rrow.rem);
							rrow.row.classList.remove('t-hidden');
							
							// remove option from TimoSelect
							selected.className = 't-hidden';
							selected.setAttribute('disabled',true);
							this._comboBox.value = '';
							this._noneleft.classList.add('t-hidden');
							
							// remove highlightclass
							wait(150).then(() => {
								trow.row.classList.remove(this._options.highlightclass);
								rrow.row.classList.remove(this._options.highlightclass);
							});
							
							wait(1000).then(() => {
								rrow.row.classList.remove('t-background-color-transition');
							});
						}
					}
				})
			}

			// listen to remove button clicks
			this._tablerows.forEach((trow) => {
				
				// setup interaction on remove button click
				if (trow.rem) {
					trow.rem.addEventListener('click', () => {
						trow.row.classList.add(this._options.highlightclass);
						wait(200).then(() => {
							this.removeRow(trow);
							this.addToSelector(trow.name);
						});
						// also hide the mobile version
						const rrow = this._revealerrows.find((r) => r.name === trow.name)
						this.removeRow(rrow);
						
					})
				}
			});
			
			// listen to remove button clicks
			this._revealerrows.forEach((rrow) => {

				// setup interaction on remove button click
				if (rrow.rem && rrow.rem.classList?.contains('c-insurance-compare__removal__wrapper')) {
					rrow.rem?.firstElementChild.addEventListener('click', () => {
						rrow.row.classList.add('t-background-color-transition');
						rrow.row.classList.add(this._options.highlightclass);
						wait(200).then(() => {
							this.removeRow(rrow);
							this.addToSelector(rrow.name);
						});
						// also hide the desktop version
						const trow = this._tablerows.find((r) => r.name === rrow.name)
						this.removeRow(trow);
					})
				}
			});
			
		}
	}
	
	addToSelector(selected) {
		const chosenOption = this._selectOptions?.find(o => o.id === selected);
		chosenOption.className = '';
		chosenOption.removeAttribute('disabled');
		let options = this._selectOptions;
		if (options?.some(o => !o.hasAttribute('disabled'))) {
			this._comboBox.disabled = false;
			this._selectConfirm.disabled = false;
		}
		if (options?.every(o => !o.hasAttribute('disabled'))) {
			this._noneleft.classList.remove('t-hidden');
		}
	}

	// hide the row on the revealer on remove
	removeRow(r) {
		if (!r || !r.row) {
			return;
		}
		
		// close detail toggle
		if (r.toggleBtn && r.toggleBtn.getAttribute('aria-checked') == 'true') {
			r.toggleBtn.click();
		}
		// also close revealer if open
		if (r.rev && r.rev.getAttribute('aria-expanded') == 'true') {
			r.rev.click();
		}
		
		r.row.classList.add('t-hidden');
		r.row.classList.add(this._options.highlightclass);
		if (r.rev) {
			r.row.classList.add('t-background-color-transition');
		}
	}
}

export default CompareInsuranceTable;